import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function JealousNav() {
  return <div className="fixed top-[44px] left-0 w-full z-40 bg-white px-4" style={{
    height: '60px',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 2px 10px rgba(0,0,0,0.02)'
  }} data-id="element-341">
      <div className="max-w-7xl mx-auto h-full flex items-center justify-between" data-id="element-342">
        <a href="/" className="flex items-center gap-2" data-id="element-343">
          <img src="https://cdn.magicpatterns.com/uploads/sykPyMhrnFn2Nd2ic3YXUa/BlueCactus_Power_Washing_Icon_2.svg" alt="Blue Cactus Power Washing" className="h-9 w-9" data-id="element-344" />
          <span style={{
          color: '#3B8AC4',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: '18px',
          letterSpacing: '-0.02em'
        }} data-id="element-345">
            Blue Cactus Power Washing
          </span>
        </a>

        <div className="flex items-center gap-4" data-id="element-346">
          <a href="tel:4805998442" className="hidden sm:flex items-center gap-2 transition-opacity hover:opacity-80" style={{
          color: '#4F5B69',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 600,
          fontSize: '14px'
        }} data-id="element-347">
            <PhoneIcon className="w-4 h-4" style={{
            color: '#3B8AC4'
          }} data-id="element-348" />
            (480) 599-8442
          </a>
          <a href="#package" className="px-4 py-2 rounded-lg transition-all hover:-translate-y-0.5" style={{
          backgroundColor: '#3B8AC4',
          color: '#FFFFFF',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '13px',
          boxShadow: '0 4px 10px rgba(59,138,196,0.2)'
        }} data-id="element-349">
            Get This Deal
          </a>
        </div>
      </div>
    </div>;
}